// UI-9b: project image storage.
// The image is referenced by a short string stored in a hidden project Property
// (`@zaya.project.image`) — the property value column is VARCHAR(255), so we NEVER store
// image bytes there. The value is either:
//   - an absolute http(s) URL the user pasted, or
//   - the relative download URL of an AttachedFile (the uploaded file, stored in core).
// `resolveProjectImage` turns that stored value into a renderable <img> src.
import {appendShortTermToken} from '@/utils/token-utils.js';

export const PROJECT_IMAGE_KEY = '@zaya.project.image';

export function resolveProjectImage(value, host, shortTermToken) {
  if (!value) {
    return null;
  }
  if (/^https?:\/\//i.test(value) || value.startsWith('data:')) {
    return value;
  }
  // Relative AttachedFile download URL → absolute + short-term auth token.
  return appendShortTermToken(host + value, shortTermToken);
}
